import axios from '@lib/axios';
import { useMutation, useQueryClient, } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export interface RecipientInputs {
  name: string;
  email: string;
  phone: string;
  active?: boolean;
  listIds?: string[];
}

interface SaveRecipientProps {
  recipientId?: string;
  companyId: string;
	onSuccess?: (data: AxiosResponse) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useSaveCompanyRecipient = ({
  recipientId,
  companyId,
	onSuccess,
  onError
}: SaveRecipientProps) => {
  const queryClient = useQueryClient();
	const {
		isPending,
		isError,
		error,
		mutate: onSaveCompanyRecipient,
	} = useMutation({
		mutationFn: async (inputs: RecipientInputs) => {
      if (recipientId)
        return axios.patch(`/recipients/${recipientId}`, inputs);
      
      return axios.post('/recipients', {...inputs, companyId });
		},
		onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['company', companyId] });
      if (recipientId)
        queryClient.invalidateQueries({ queryKey: ['recipient', recipientId] });
      if (onSuccess)
        onSuccess(data);
    },
    onError
	});

	return { onSaveCompanyRecipient, isPending, isError, error };
};
